module.exports = __webpack_public_path__ + "img/88.2124fa6d.jpg";